import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form, Button, FormInstance } from 'antd';
import useQueryApiClient from 'utils/useApiClient';
import { useT } from 'hooks/Locale/useT';

import './styles.scss';

const VARIABLE_NODE_CLASS_NAME = 'email_template.variable';

type HtmlEditor = {
    selection: {
        insertHTML: (html: string) => void;
    };
};

interface VariablesInterface {
    mailable: string | null;
    editor?: HtmlEditor | null;
    form: FormInstance;
    inputType?: 'htmlTemplate' | 'smsTemplate';
}

const Variables: React.FC<VariablesInterface> = ({
    mailable = null,
    editor = null,
    form,
    inputType = 'htmlTemplate',
}) => {
    const [variables, setVariables] = useState<string[]>([]);
    const t = useT();

    useEffect(() => {
        if (mailable) {
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mailable]);

    const { fetch } = useQueryApiClient({
        request: {
            url: `/api/v1/mail-templates/standard/${mailable}/variables`,
            disableOnMount: true,
        },
        onSuccess: (response): void => {
            setVariables(response);
        },
    });

    const addVariableToSmsTemplate = (variable: string): void => {
        const current = (form.getFieldValue('smsTemplate') as string | undefined) ?? '';
        const updated = `${current} |*${variable}*| `;

        form.setFieldsValue({
            smsTemplate: updated,
        });
    };

    return (
        <Form.Item label={t('general.variables')}>
            {variables && variables.length > 0 ? (
                variables.map((variable: string) => {
                    if (variable === 'mailTemplate') {
                        return;
                    }

                    return (
                        <Button
                            size="small"
                            className="emailing-variables-button"
                            onClick={() => {
                                if (inputType === 'htmlTemplate' && editor) {
                                    editor.selection.insertHTML(
                                        `<span data-variable="${variable}" class="${VARIABLE_NODE_CLASS_NAME}">{{${t(
                                            'email_template.variable.' + variable
                                        )}}}</span> `
                                    );
                                } else if (inputType === 'smsTemplate') {
                                    addVariableToSmsTemplate(variable);
                                }
                            }}
                        >
                            <FormattedMessage id={`email_template.variable.${variable}`} />
                        </Button>
                    );
                })
            ) : (
                <div className="c-red">
                    <FormattedMessage id={'emailing.templates.choose_mailable'} />
                </div>
            )}
        </Form.Item>
    );
};

export default Variables;
